var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { useQuery } from '@apollo/client';
import useInfiniteScroll from 'react-infinite-scroll-hook';
import { get } from 'lodash';
export function useInfiniteScrollQuery(args) {
  var variables = __assign({
    limit: 50
  }, args.variables || {});
  var _a = args.headers,
    headers = _a === void 0 ? {} : _a,
    skip = args.skip,
    _b = args.fetchPolicy,
    fetchPolicy = _b === void 0 ? "network-only" : _b,
    _c = args.notifyOnNetworkStatusChange,
    notifyOnNetworkStatusChange = _c === void 0 ? true : _c;
  var query = args.query,
    resultsKey = args.resultsKey,
    isReverse = args.isReverse,
    _d = args.rootMargin,
    rootMargin = _d === void 0 ? "0px 0px 100px 0px" : _d;
  var _e = useQuery(query, {
      fetchPolicy: fetchPolicy,
      notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
      variables: variables,
      skip: skip,
      context: {
        headers: headers
      }
    }),
    loading = _e.loading,
    data = _e.data,
    fetchMore = _e.fetchMore;
  // console.log("LOADING", loading, "SKIP", skip);
  var items = get(data, "".concat(resultsKey, ".results"), []);
  var meta = get(data, "".concat(resultsKey, ".meta"), {
    count: 0,
    total: 0
  });
  var hasNextPage = meta.total > items.length;
  var params = {
    variables: __assign(__assign({}, variables), {
      skip: items.length
    }),
    updateQuery: function (prev, _a) {
      var _b;
      var fetchMoreResult = _a.fetchMoreResult;
      if (!fetchMoreResult) return prev;
      var resultPrev = get(prev, resultsKey, {
        results: []
      });
      var result = get(fetchMoreResult, resultsKey, {
        results: []
      });
      var newResult = (_b = {}, _b[resultsKey] = __assign(__assign({}, resultPrev), {
        results: isReverse ? __spreadArray(__spreadArray([], __read(result.results), false), __read(items), false) : __spreadArray(__spreadArray([], __read(items), false), __read(result.results), false)
      }), _b);
      return newResult;
    }
  };
  // onLoadMore is a callback sent to useInfiniteScroll which is called when the user scrolls toward the sentry ref
  var onLoadMore = function () {
    fetchMore(params);
  };
  var _f = __read(useInfiniteScroll({
      loading: loading,
      hasNextPage: hasNextPage,
      onLoadMore: onLoadMore,
      disabled: false,
      rootMargin: rootMargin
    }), 2),
    sentryRef = _f[0],
    rootRef = _f[1].rootRef;
  return {
    items: items,
    loading: loading,
    meta: meta,
    hasNextPage: hasNextPage,
    sentryRef: sentryRef,
    rootRef: rootRef
  };
}
;